import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useSwitchFulfillmentDashboardToRawEndpoint = () => {
  return useFeatureFlag(FeatureFlagDeclarations.switchFulfillmentDashboardToRawEndpoint);
};
